import React, { Component, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import * as R from "ramda";
import { Route, Switch, Redirect, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { fetchaAllPartnersInvoices, fetchAllClientsInvoices, fetchClientsInvoices, fetchPartnersInvoices } from '../../actions/backoffice/payments';
import * as Loadings from '../../constants/loadings/backoffice/payments';
import { LoadingState } from '../../_common/loadingState';

import { PaiementHeader } from './_common/header';
import { PaiementClients } from './clients';
import { PaiementPartners } from './partners';

export const Paiement = () => {

	const paymentState = useSelector(state => state.paymentReducer);

	return (
		<article className="view-calc pt-4 mb-auto pb-sm">
			<PaiementHeader paymentState={paymentState} />
			<Switch>
				<Route exact path="/backoffice/paiement" >
					<PaiementClients paymentState={paymentState} />
				</Route>
				<Route path="/backoffice/paiement/partners">
					<PaiementPartners paymentState={paymentState} />
				</Route>
				<Route render={() => {
					return <Redirect exact to="/backoffice/paiement" />;
				}} />
			</Switch>
		</article>
	);

};

